<template>
  <v-row>
    <template v-if="api.user_permissions.includes('owner_api')">
      <v-row
      >
        <v-col cols="2">
          <v-subheader class="font-weight-bold subheading">
            Share API to
          </v-subheader>
        </v-col>
        <!-- user search and invite START -->
        <v-col cols="3">
          <v-autocomplete
            v-model="selectedUser"
            :loading="loading"
            :items="items"
            :search-input.sync="search"
            cache-items
            flat
            hide-no-data
            hide-details
            label="username"
          />
        </v-col>
        <v-col
          cols="3"
        >
          <v-select
            v-model="selectedPermission"
            :items="permissions"
            label="Select"
            single-line
            auto
            hide-details
          />
        </v-col>
        <div>
          <v-btn
            class="ml-5 mt-5"
            @click.native="sendInvite(selectedUser, selectedPermission)"
          >
            <v-icon left>
              mdi-share-variant
            </v-icon> Share
          </v-btn>
        </div>
        <!-- user search and invite END -->
      </v-row>
    </template>
    <template v-if="api.permissions.length > 0">
      <v-card-text>
        <h2 class="headline">
          <v-icon>
            mdi-account-group
          </v-icon> Team
        </h2>
      </v-card-text>
      <v-container grid-list-lg>
        <v-row>
          <!-- user cards START -->
          <v-col
            v-for="user in api.permissions"
            :key="user.id"
            cols="12"
            sm="6"
            md="4"
            lg="4"
          >
            <user-member-card
              :user="user"
              :api="api"
              :user-permissions="api.user_permissions"
              type="api"
              @modifyPermissions="modifyPermissions"
            />
          <!-- user cards END -->
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-else>
      <v-card-text>
        <h2 class="headline primary--text">
          no users
        </h2>
      </v-card-text>
    </template>
  </v-row>
</template>

<script>
  import ApiService from './services/ApiService'
  import UserMemberCard from '../../../UIComponents/Cards/UserMemberCard.vue'
  import NewJumbotron from '../../../UIComponents/Jumbotron.vue'

  export default {
    components: {
      UserMemberCard,
      NewJumbotron,
    },
    props: {
      api: {},
      myJumbotron: {},
    },
    data: function () {
      return {
        permissions: [
          { text: 'Can view', value: ['read_api'] },
          { text: 'Can edit', value: ['read_write_api'] },
          { text: 'Can manage', value: ['owner_api'] },
        ],

        selectedPermission: {},
        selectedUser: '',
        loading: false,
        items: [],
        search: null,
      }
    },
    watch: {
      search (val) {
        val && val !== this.selectedUser && this.querySelections(val)
      },
    },
    methods: {
      sendInvite (user, permission) {
        if (user !== '' && Object.keys(permission).length !== 0) {
          ApiService.addPermission(this, this.api, user, permission)
        }
      },
      modifyPermissions (myObject) {
        this.$emit('modifyPermissions', myObject)
      },
      querySelections (v) {
        this.loading = true
        setTimeout(() => {
          DatasetService.searchUsers(v, this)
            .then(response => {
              this.items = []
              var results = response.data.results
              var item
              for (item in results) {
                this.items.push(results[item].email)
              }
              this.loading = false
            }).catch(error => {
              this.loading = false
            })
        }, 1000)
      },
    },
  }
</script>
